"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_redux_1 = require("react-redux");
var contests_core_1 = require("@biw/contests-core");
var final_result_props_1 = tslib_1.__importDefault(require("./manager/final-result-props"));
var goal_selection_props_1 = tslib_1.__importDefault(require("./manager/goal-selection-props"));
var no_progress_props_1 = tslib_1.__importDefault(require("./manager/no-progress-props"));
var overview_props_1 = tslib_1.__importDefault(require("./manager/overview-props"));
var progress_props_1 = tslib_1.__importDefault(require("./manager/progress-props"));
var final_result_props_2 = tslib_1.__importDefault(require("./participant/final-result-props"));
var program_overview_props_1 = tslib_1.__importDefault(require("./participant/program-overview-props"));
var goal_selected_props_1 = tslib_1.__importDefault(require("./participant/goal-selected-props"));
var no_goal_selected_props_1 = tslib_1.__importDefault(require("./participant/no-goal-selected-props"));
var no_progress_props_2 = tslib_1.__importDefault(require("./participant/no-progress-props"));
var progress_props_2 = tslib_1.__importDefault(require("./participant/progress-props"));
var waiting_for_final_results_props_1 = tslib_1.__importDefault(require("./participant/waiting-for-final-results-props"));
var getTileProps = function (state, program) {
    if (program.isManager) {
        if (program.isObjectives && (!program.hasProgress || !program.programHasStarted)) {
            return overview_props_1.default(state, program);
        }
        else if (!program.isObjectives && !program.goalSelectionPeriodHasEnded) {
            return goal_selection_props_1.default(state, program);
        }
        else if (!program.hasProgress) {
            return no_progress_props_1.default(state, program);
        }
        else if (program.isFinalResults) {
            return final_result_props_1.default(state, program);
        }
        else {
            return progress_props_1.default(state, program);
        }
    }
    if (program.isGoalSelection) {
        return program_overview_props_1.default(state, program);
    }
    else if (program.missedGoalSelection) {
        return no_goal_selected_props_1.default(state, program);
    }
    else if (program.hasGoalSelectedAndInGoalSelectionPeriod) {
        return goal_selected_props_1.default(state, program);
    }
    else if (!program.hasProgress) {
        if (program.isObjectives && !program.programHasStarted) {
            return program_overview_props_1.default(state, program);
        }
        return no_progress_props_2.default(state, program);
    }
    else if (program.hasProgress && !program.isFinalResults) {
        return program.isCheckingResults ?
            waiting_for_final_results_props_1.default(state, program) :
            progress_props_2.default(state, program);
    }
    else if (program.isFinalResults) {
        return final_result_props_2.default(state, program);
    }
    // default if nothing is found so that we show *something*
    return program_overview_props_1.default(state, program);
};
exports.mapStateToProps = function (state, _a) {
    var _b = _a.program, program = _b === void 0 ? {} : _b;
    var programViewId = program.programViewId;
    var progressModel = contests_core_1.progress.selectors.getProgress(state, programViewId) || {};
    return tslib_1.__assign({ program: program, programType: program.programType, programName: program.programName, programLogo: program.programLogo, programViewId: program.programViewId, programViewStatus: program.programViewStatus, heroImageUrl: program.heroImageUrl, endDate: program.endDate, startDate: program.startDate, goalSelectionToDate: program.goalSelectionToDate, lastDayLeftDate: program.endDate, isOwnerEligibleForAward: program.isOwnerEligibleForAward, isObjectives: program.isObjectives, isManager: program.isManager, programHasEnded: program.programHasEnded, programHasStarted: program.programHasStarted, checkingResults: program.isCheckingResults, finalResult: contests_core_1.progress.selectors.getProgramViewFinalResults(state, programViewId), goal: contests_core_1.progress.selectors.getProgramViewGoal(state, programViewId), progressLastUpdated: progressModel.progressLastUpdated, progressLoading: contests_core_1.progress.selectors.getProgressIsFetching(state, programViewId), hasProgressData: Object.keys(contests_core_1.progress.selectors.getProgramViewProgressData(state, programViewId)).length > 0, finalResultCode: contests_core_1.progress.selectors.getResultCode(state, programViewId), progressLastUpdatedCode: 'programInfoHeader.dataThrough' }, getTileProps(state, program));
};
exports.default = react_redux_1.connect(exports.mapStateToProps);
//# sourceMappingURL=enhancer.js.map